angular.module('bmsApp.sm.job')
	.controller('SMJobSaveCtrl', [
		'$log',
		'$state',
		'$scope',
		'SMJobSvc',
		'LicenseOptionsSvc',
		'$q',
		'SecurityTypeSvc',
		'TaxHelperSvc',
		'SMCleaningServiceSvc',
		'SMScheduleSvc',
		'EmployeeSvc',
		'$mdDialog',
		'notify',
		'ProximitySvc',
		function ($log,
				  $state,
				  $scope,
				  SMJobSvc,
				  LicenseOptionsSvc,
				  $q,
				  SecurityTypeSvc,
				  TaxHelperSvc,
				  SMCleaningServiceSvc,
				  SMScheduleSvc,
				  EmployeeSvc,
				  $mdDialog,
				  notify,
				  ProximitySvc) {

			function init() {
				self.updating = $state.is('main.sm.quote.index.view.convert') ? false : true;
				self.quoteId = self.updating ? $state.params.jobId : $state.params.quoteId;

				let preferredEmployeeOptionsPromise = EmployeeSvc.index({
					filter: {
						// status: true,
					},
				})
					.then((response) => {
						self.options.preferredEmployee = response.data.employee_collection;
					});

				var promises = {
					job: SMJobSvc.read(self.quoteId),
					licenseOptions: LicenseOptionsSvc.license(),
					securityTypes: SecurityTypeSvc.options(),
					vatRate: TaxHelperSvc.setVatRate(),
					employeeOptions: preferredEmployeeOptionsPromise,
				};

				$q.all(promises)
					.then(function (responses) {
						self.job = responses.job.data.sm_job;
						self.options.license = responses.licenseOptions.data.options;
						self.options.securityTypes = responses.securityTypes.data.options;

						angular.extend($scope, {
							quote: {
								name: angular.copy(self.job.quote_name)
							},
							job: {
								name: angular.copy(self.job.id)
							}
						});

						// Set the time
						angular.forEach(self.job.visits, function(visit) {
							var visitDate = moment(visit.visit_date);
							angular.extend(visit, {
								visit_time: visitDate
							});
							minutesUpdated(visit);
							// visitDateSelected(visit); // initially load the employees list for each visit
						});

						if (self.job.visits.length <= 0) {
							addVisit(self.job.duration_in_mins); // add a default visit
						}

						self.loading = false;
					});

				$scope.$watch(function () {
					return self.job;
				}, function (job) {
					if (angular.isObject(job)) {
						SMJobSvc.calcValue(job);
					}
				}, true);
			}

			function addCleaningService() {
				SMCleaningServiceSvc.showCleaningServiceModal(null, self.job.license_id)
					.then(function (result) {
						angular.extend(result.cleaningService,{
							accepted: true,
							satisfied: true,
						})
						self.job.scheduled_cleaning_services.push(result.cleaningService);
					});
			}

			function editCleaningService(item) {
				console.info(item);
				SMCleaningServiceSvc.showCleaningServiceModal(item, self.job.license_id)
					.then(function (result) {
						angular.extend(item, result.cleaningService);
					});
			}

			function deleteCleaningService(item) {
				if (item.added) {
					self.job.scheduled_cleaning_services.splice(self.job.scheduled_cleaning_services.indexOf(item), 1);
				}
				else {
					angular.extend(item, {
						delete: true
					});
				}
			}

			function undoDeleteCleaningService(item) {
				angular.extend(item, {
					delete: false
				});
			}

			function addVisit(defaultMins) {
				self.job.visits.push({
					duration_in_mins: (angular.isDefined(defaultMins)) ? defaultMins : 0,
					employees: [
						{}
					]
				});
			}


			function visitEmployeeChanged(visit, employee) {
				// Check the visit doesn't already contain this employee
				var alreadyUsedCount = 0;
				angular.forEach(visit.employees, function (existingEmployee) {
					if (existingEmployee.id === employee.id) {
						alreadyUsedCount++;
					}
				});

				if (alreadyUsedCount > 1) {
					employee.id = null;
					$mdDialog.show(
						$mdDialog.alert()
							.clickOutsideToClose(true)
							.title('Can\'t set employee')
							.textContent('This employee is already assigned to the visit')
							.ariaLabel('employee')
							.ok('Okay')
					);
				}
			}

			// ------------------------------- VisitList Directives Callbacks ----------------------------
			function minutesUpdated(visit) {
				if (visit) {
					var hours = visit.hours || 0;
					var mins = visit.minutes || 0;
					visit.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
				}

				var totalMinutes = self.job.duration_in_mins;
				var totalAllocated = 0;
				angular.forEach(self.job.visits, function (visit) {
					if (angular.isNumber(parseFloat(visit.duration_in_mins))) {
						totalAllocated += parseFloat(visit.duration_in_mins);
					}
				});


				self.job.totalAllocatedMins = totalAllocated;
				self.job.totalRemainingAllocated = totalMinutes - totalAllocated;

			}

			function removeVisit(visit) {
				if (visit.id) {
					visit.delete = true;
				}
				else {
					self.job.visits.splice(self.job.visits.indexOf(visit), 1);
				}
			}

			function showAvailabilityModal() {
				SMScheduleSvc.showAvailabilityModal(self.job).then(function(result) {
					self.job.visits = [];
					angular.extend(self.job, {
						visits: [
							{
								employees: [
									result.employee
								],
								duration_in_mins: self.job.hours * 60 + self.job.minutes,
								hours: parseFloat(self.job.hours),
								minutes: parseFloat(self.job.minutes),
								visit_date: result.dateTime,
								visit_time: result.dateTime

							}
						]
					});
					jobDurationUpdated();
				});
			}

			function showProximityLocatorModal(){
				var hours = self.job.hours || 0;
				var mins = self.job.minutes || 0;
				self.job.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
				ProximitySvc.showLocatorModal(self.job.license, self.job.site.postcode, self.job.duration_in_mins)
					.then(function (result) {
						self.job.visits = [];
						self.job.visits.push({
							employees: [
								result.employee
							],
							hours: self.job.hours,
							minutes: self.job.minutes,
							visit_date: result.dateTime,
							visit_time: result.dateTime
						});
					});
			}
			// END ----------------------------------------------------------------------------------------



			function jobDurationUpdated() {
				var hours = self.job.hours || 0;
				var mins = self.job.minutes || 0;
				self.job.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
				minutesUpdated(null);
			}

			function submit() {

				// if (self.job.totalRemainingAllocated != 0) {
				// 	notify({
				// 		message: 'You must allocate the exact amount of minutes',
				// 		classes: 'error'
				// 	});
				// 	return;
				// }
				var converting = (self.job.converted) ? false : true;
				self.processing = true;
				// self.job.converted = true;
				// self.job.converted_at = moment().format('YYYY-MM-DD');
				self.job.converting = converting;

				if (self.formValidator.valid()) {

					let availabilityChecks = [];
					// combine the date/time columns
					angular.forEach(self.job.visits, function(visit) {
						angular.extend(visit, {
							visit_date: moment(visit.visit_date).format('YYYY-MM-DD') + ' ' + visit.visit_time.format('HH:mm:ss')
						});
						let job = {
							id: self.job.id,
						};
						if (!visit.delete) {
							let requiredCheckCount = Math.max(visit.employees.length, 1);
							for(let i = 0; i < requiredCheckCount; i++) {
								let employeeData;
								let employee = visit.employees[i];
								if (employee) {
									employeeData = {
										id: employee.id,
									};
								} else {
									employeeData = null;
								}
								availabilityChecks.push(
									SMJobSvc.checkVisitAvailability(visit, employeeData, job)
								);
							}
						}
					});
					let visitsAvailable = true;
					$q.all(availabilityChecks)
						.then(function (responses) {
							angular.forEach(responses, function (response) {
								if (response.data.is_available !== true) {
									visitsAvailable = false;
									notify({
										message: 'Cannot save visit: employee is already booked, please check availability schedule',
										classes: 'error',
										duration: '0'
									});
								}
							});
							if (!visitsAvailable) {
								self.processing = false;
								return;
							}
							SMJobSvc.save(self.job)
								.then(function (response) {
									if (converting) {
										notify({
											message: 'Successfully converted quote'
										});
									}
									else {
										notify({
											message: 'Successfully updated job'
										})
									}

									 $state.go('main.sm.job.index.view', {jobId: response.data.sm_job.id});
								}, function (errors) {
									self.errors = errors;
								})
								.finally(function () {
									self.processing = false;
								});
						});
				}
				else {
					self.processing = false;
				}
			}

			var self = $scope.SMJobSaveCtrl = {
				loading: true,
				processing: false,
				options: {},
				methods: {
					init: init,
					submit: submit,
					addCleaningService: addCleaningService,
					editCleaningService: editCleaningService,
					deleteCleaningService: deleteCleaningService,
					undoDeleteCleaningService: undoDeleteCleaningService,
					addVisit: addVisit,
					visitEmployeeChanged: visitEmployeeChanged,
					minutesUpdated: minutesUpdated,
					jobDurationUpdated: jobDurationUpdated,
					removeVisit: removeVisit,
					showAvailabilityModal: showAvailabilityModal,
					showProximityLocatorModal: showProximityLocatorModal,
				}
			};

		}
	])
;
